import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import {
  About,
  Contact,
  Experience,
  Certifications,
  Hero,
  Navbar,
  Works,
  UpToTopButton,
} from "./components";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import { useIntersectionObserver } from "./hooks/useIntersectionObserver";
import { initAutoTracking } from "./services/trackingService";

const Tech = lazy(() => import("./components/Tech"));
const StarsCanvas = lazy(() => import("./components/canvas/Stars"));
const AllCertifications = lazy(() => import("./pages/AllCertifications"));
const AutomotoraLanding = lazy(() => import("./pages/AutomotoraLanding"));

const HomePage = () => {
  const [techRef, , techHasBeenVisible] = useIntersectionObserver({ rootMargin: '200px' });
  const [starsRef, , starsHasBeenVisible] = useIntersectionObserver({ rootMargin: '200px' });

  useEffect(() => {
    initAutoTracking();
  }, []);

  return (
    <div className="relative z-0 bg-primary transition-colors duration-300">
      <Navbar />
      <UpToTopButton />
      <WhatsAppButton visible={true} />
      <div className="bg-cover bg-no-repeat bg-center">
        <Hero />
      </div>
      <main>
        <About />
        <Experience />
        <Certifications />
        <div ref={techRef} className={!techHasBeenVisible ? "md:min-h-[420px]" : ""}>
          {techHasBeenVisible && (
            <Suspense fallback={<div className="md:min-h-[420px]" />}>
              <Tech />
            </Suspense>
          )}
        </div>
        <Works />

        {/*<Feedbacks />*/}
        <div className="relative z-0">
          <Contact />
          <div ref={starsRef}>
            {starsHasBeenVisible && (
              <Suspense fallback={null}>
                <StarsCanvas />
              </Suspense>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/certificaciones"
          element={
            <Suspense fallback={null}>
              <AllCertifications />
            </Suspense>
          }
        />
        <Route
          path="/sistema-para-automotoras"
          element={
            <Suspense fallback={null}>
              <AutomotoraLanding />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
